// src/api/authApi.js
import { BASE_URL, authFetch } from "./apiConfig";

// 🔑 Login user → get tokens
export const loginUser = async (email, password) => {
  const res = await fetch(`${BASE_URL}/accounts/token/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Login failed");
  }

  const data = await res.json();
  localStorage.setItem("access", data.access);
  localStorage.setItem("refresh", data.refresh);
  return data;
};

// 📝 Signup user (you can expand later)
export const signupUser = async (userData) => {
  const res = await fetch(`${BASE_URL}/accounts/register/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userData),
  });

  if (!res.ok) {
    const err = await res.json();
    // Throw error object instead of just string to allow detailed handling
    const error = new Error(err.detail || "Signup failed");
    error.data = err;
    throw error;
  }

  return res.json();
};

// 🚪 Logout → blacklist refresh token
export const logoutUser = async () => {
  const refresh = localStorage.getItem("refresh");
  if (!refresh) return;

  await fetch(`${BASE_URL}/accounts/logout/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh }),
  });

  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
};

// 👤 Get user profile
export const getUserProfile = async () => {
  return authFetch("/accounts/me/");
};

// 👥 Get organizer profile
export const getOrganizerProfile = async () => {
  return authFetch("/organizers/me/");
};

// 🎟️ Onboard organizer
export const onboardOrganizer = async (organizerName) => {
  return authFetch("/organizers/onboard/", {
    method: "POST",
    body: JSON.stringify({ organization_name: organizerName }),
  });
};

// 🔒 Password reset → send reset email
export const passwordReset = async (email) => {
  const res = await fetch(`${BASE_URL}/accounts/password-reset/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Password reset failed");
  }

  return res.json();
};

// 🔑 Confirm password reset
export const passwordResetConfirm = async (uid, token, newPassword) => {
  const res = await fetch(`${BASE_URL}/accounts/password-reset/confirm/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, token, new_password: newPassword }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Invalid or expired token");
  }

  return res.json();
};

// 🔐 Change password
export const changePassword = async (oldPassword, newPassword) => {
  return authFetch("/accounts/password/change/", {
    method: "POST",
    body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
  });
};

// ❤️ Get wishlisted events
export const getWishlistedEvents = async () => {
  return authFetch("/attendee/saved/");
};

// ❤️ Add to wishlist
export const addToWishlist = async (eventId) => {
  return authFetch("/attendee/saved/", {
    method: "POST",
    body: JSON.stringify({ event_id: eventId }),
  });
};

// ❤️ Remove from wishlist
export const removeFromWishlist = async (eventId) => {
  return authFetch(`/attendee/saved/${eventId}/`, {
    method: "DELETE",
  });
};

// 🎟️ Get organizer events
export const getOrganizerEvents = async () => {
  return authFetch("/organizers/me/events/");
};

// 📩 Resend Email Verification
export const resendEmailVerification = async (email) => {
  const res = await fetch(`${BASE_URL}/accounts/email-verify/resend/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Failed to resend verification email");
  }

  return res.json();
};

// ✅ Confirm Email Verification
export const confirmEmailVerification = async (uid, token) => {
  const res = await fetch(`${BASE_URL}/accounts/email-verify/confirm/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, token }),
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Invalid or expired token");
  }

  return res.json();
};
